module.exports = __webpack_public_path__ + "res/glyphicons-halflings-regular.ttf?e18bbf611f2a2e43afc071aa2f4e1512";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.ttf
// module id = 8
// module chunks = 0